import React from "react";
import { Colors } from "../../utils/colors";
import { observer } from "mobx-react-lite";
import { usePaymentStore, useUserStore } from "../../stores/StoreContext";
import { RadioButton } from "../radioButton/RadioButton";
import { TCText } from "../TCText/TCText";
import { BookingPaymentType } from "../../utils/data";

type props = {};

export const EWalletPayment: React.FC<props> = observer(() => {
  const paymentStore = usePaymentStore();
  const userStore = useUserStore();
  return (
    <div
      style={{
        border: `2px solid ${Colors.green}`,
        width: "100%",
        display: "flex",
        padding: "15px 20px",
        borderRadius: 20,
        marginBottom: 20,
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      <div>
        <TCText
          style={{ color: Colors.green, fontWeight: 600, fontSize: 15 }}
          value="Club Credits"
        />
        <TCText
          style={{ color: Colors.green, fontWeight: 600, fontSize: 15 }}
          value={`Balance : ${userStore.userModel?.eWalletBalance.toFixed(2)}`}
        />
      </div>
      <RadioButton
        selected={
          paymentStore.selectedPaymentMethod === BookingPaymentType.WALLET
        }
        onChange={() => {
          paymentStore.setSelectedPaymentMethod(BookingPaymentType.WALLET);
        }}
      />
    </div>
  );
});
